
import SEO from '@/services/seo'
import Provider from '@/services/provider'
import { head } from '@/utils/head'
import gtm from '@/mixins/gtm'
import { getPageBySlug } from '@/services/fetch/modules/cms'

export default {
  mixins: [gtm],
  nuxtI18n: {
    parsePages: false,
    locales: ['pt-br', 'en', 'es', 'fr', 'ja', 'it', 'de', 'nl'],
  },

  data() {
    return {
      gtmSubsection2: 'Home',
      home: [],
      isAwaitingResponse: true,
    }
  },

  fetchKey: 'home',

  async fetch() {
    const locale = this.$i18n.locale

    this.home = await getPageBySlug(locale, 'home')
    this.isAwaitingResponse = false
  },

  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    let title = this.$t('seo.shared.title')
    let description = this.$t('seo.shared.description')
    const url = `${process.env.BASE_URL}${this.$route.path}`

    return head({
      title,
      description,
      url,
      canonical: url,
      htmlAttrs: { ...i18nHead.htmlAttrs },
      link: SEO.linkAlternate.setList(this.$route.name),
      breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
    })
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
}
